module.exports = __webpack_public_path__ + "img/bb-scroll-top-arrow.fe92f5ed.svg";